export default {
  usuarios: [],
  // Objeto padrão de usuário
  userData: {
    nome: '',
    email: '',
    celular: '',
    tipo: '',
    senha: null,
    confSenha: null,
    foto: null,
    empresas: [],
    contatoOperacional: {
      nomeResponsavel: '',
      emailResponsavel: '',
    },
  },
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    codigo: '',
    nome: '',
    email: '',
    tipo: '',
    dataCriacao: '',
    dataCriacaoCondicao: '',
    ultimoAcesso: '',
    ultimoAcessoCondicao: '',
    order: 'NOME_PESSOA',
    direcao: 'ASC',
  },
  campos: {
    id: 'ID',
    nome: 'NOME_PESSOA',
    email: 'EMAIL',
    tipo: 'TIPO',
    dataCriacao: 'DATA_CRIACAO',
    ultimoAcesso: 'ULTIMO_ACESSO',
  },
  colDefault: 'NOME_PESSOA',
  directionDefault: 'ASC',
  termsConditions: false,
};
